export default __webpack_public_path__ + "static/media/Ballroll_00108.eb44b94c.png";